import { Box, Grid, Theme, ThemeOptions, Typography } from '@mui/material';
import { KeyValue } from './personalDetails';
import { SubHeading } from '../investors/components';
import React from 'react';
import { Gridstyles } from './index';
import { Applicant, DataMaster, FamilyMembers } from '../../redux-store/types/api-types';
import { formatShortDate } from '../../utils/date';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { ADDITIONAL_KYC_DETAILS_CATEGORY, dndValue, USER_ROLES } from '../../utils/constant';
import { capitalize, toINR } from '../../utils/utilityFunctions';

export default function KycDetails({
  applicants = [],
  families = [],
  dataMasters
}: {
  applicants: Partial<Applicant>[];
  families: Partial<FamilyMembers>[];
  dataMasters: DataMaster
}): JSX.Element {
  const { locale, currencyCode, currencySymbol } = useSelector((store: RootStateType) => store.currencyInfo);
  const { role } = useSelector((store: RootStateType) => store.auth);

  const {
    OCCUPATION = [],
    SUB_OCCUPATION = [] as any[],
    INTRODUCER = [],
    INTRODUCER_SOURCE = [] as any[],
    INTRODUCER_SUB_SOURCE = [] as any[],
  } = dataMasters || {};

  return (
    <>
      <Box
        sx={(theme: Theme) => ({
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
          borderRadius: '10px',
          border: `1px solid ${theme.palette.grey[100]}`,
          padding: '25px',
        })}
        mt={5}>
        <Box >
          <Grid container >
            <Typography sx={(theme: Theme) => ({ fontSize: 18, fontWeight: 700, color: theme.palette.primary[900], mb: '9px' })}>
              Additional Details
            </Typography>
            {applicants.map((applicant, index: number) => {
              const title = [
                'First Applicant',
                'Second Applicant',
                'Third Applicant',
              ][index];
              return (
                <React.Fragment key={applicant.id}>
                  <SubHeading sx={{ letterSpacing: "0.02px" }}>{title} Details</SubHeading>
                  <Grid
                    item
                    container
                    // pb={5}
                    rowSpacing={3}
                    columnSpacing={5.5}
                    direction="row"
                  // justifyContent="space-between"
                  // alignItems="flex-start"
                  >
                    <KeyValue
                      title={`Gross Annual Income (in ${currencyCode})*`}
                      description={applicant.grossAnnualIncome}
                    />
                    {/* <KeyValue
                      title={'Gross Annual Income as on Date'}
                      description={formatShortDate(applicant.grossAnnualIncomeDate)}
                    /> */}
                    <KeyValue title={`NetWorth (in ${currencyCode})`} description={applicant.netWorth ? `${String.fromCharCode(parseInt(currencySymbol, 16))} ${applicant.netWorth}` : '-'} />
                    {/* <KeyValue
                      title={'Networth as on Date'}
                      description={formatShortDate(applicant.netWorthDate)}
                    /> */}
                    <KeyValue
                      title={'Politically Exposed Person (PEP) Status*'}
                      description={applicant.politicallyExposedPersonStatus}
                    />
                    {[USER_ROLES.INVESTOR].includes(role) && <KeyValue title={'CKYC Number'} description={applicant.ckycNo} />}
                    {/* <KeyValue title={'Webtop Number'} description={applicant.webtopId || '-'} /> */}
                    <KeyValue title={'Occupation*'} description={OCCUPATION.find((master) => master.identifier === applicant.occupation)?.description || '-'} />
                    {/* <KeyValue title={'Sub Occupation'} description={SUB_OCCUPATION.find((master: any) => master.refDataValue === applicant.subOccupation)?.refDisplayValue || '-'} /> */}
                    {((`${applicant.occupation ?? ''}`).toLowerCase() === "occupation-others") && <KeyValue title={'Specific Occupation'} description={applicant.otherSubOccupation || '-'} />}
                    <KeyValue title={'ABCL Group Employee'} description={applicant.tataGroupEmployee ? 'Yes' : 'No'} />
                    {applicant.employer && <KeyValue title={'Name of Employer*'} description={applicant.employer || '-'} />
                    }
                    <KeyValue title={'DND Status*'} description={applicant.dnd || '-'} />
                    {/* <KeyValue title={'Branch'} description={applicant.branch || '-'} /> */}
                    {/* <KeyValue title={'Registration Number'} description={applicant.registrationNumber || '-'} /> */}
                    {USER_ROLES.INVESTOR !== role && <KeyValue title={'Deemed OVD'} description={applicant.deemedOvd ? 'Yes' : 'No'} />}
                    {/* <KeyValue title={'Gst No'} description={applicant.gst || '-'} /> */}
                    <KeyValue title={'Source of Wealth*'} description={applicant.wealthSource || '-'} />
                    {/* <KeyValue title={'Estimated Financial Wealth*'} description={applicant.financialWealth ? `${String.fromCharCode(parseInt(currencySymbol, 16))} ${applicant.financialWealth || '-'}` : '-'} /> */}
                    {/* <KeyValue title={'Account Code (L4 N0.)'} description={applicant.accountCode || '-'} /> */}
                    {/* <KeyValue title={'UCIC Number'} description={applicant.ucic || '-'} /> */}
                    {/* <KeyValue title={'Family/Sub Group'} description={applicant.subGroup || '-'} /> */}
                    {/* <KeyValue title={'Head of Family'} description={applicant.headFamily == 'true' ? 'Yes' : 'No'} /> */}
                    <KeyValue title={'Onboarding Date'} description={applicant.onboardingDate ? formatShortDate(applicant.onboardingDate) : "-"} />
                    {USER_ROLES.INVESTOR !== role && (
                      <>
                        {/* <KeyValue title={'Introducer'} description={INTRODUCER.find((master) => master.identifier === applicant.introducer)?.description || '-'} />
                        <KeyValue title={'Source'} description={capitalize(applicant.introducerSource ?? '') || '-'} />
                        <KeyValue title={'Sub Source'} description={capitalize(applicant.introducerSubSource ?? '') || '-'} />
                        <KeyValue title={'Specific Sub Source'} description={applicant.otherIntroducerSubSource || '-'} /> */}
                        {/* <KeyValue title={'Sourcing RM'} description={applicant.sourcingRm || '-'} /> */}
                        <KeyValue title={'Effective Date'} description={applicant.effectiveDate ? formatShortDate(applicant.effectiveDate) : "-"} />
                        {/* <KeyValue title={'Servicing RM'} description={applicant.servicingRm || '-'} /> */}
                        {/* <KeyValue title={'Business Unit'} description={applicant.businessUnit || '-'} /> */}
                      </>
                    )}
                    <KeyValue title={'Last Re-KYC Date'} description={applicant.lastReKycDate ? formatShortDate(applicant.lastReKycDate) : "-"} />
                    <KeyValue title={'Next Re-KYC Date'} description={applicant.nextReKycDate ? formatShortDate(applicant.nextReKycDate) : "-"} />
                    {/* {USER_ROLES.INVESTOR !== role && <KeyValue title={'Category'} description={applicant.category || '-'} />} */}
                  </Grid>
                </React.Fragment>
              );
            })}

            {/* {families.length > 0 && <Grid
              container
              direction="row"
            >
              <Grid item xs={12}>
                <SubHeading sx={{ letterSpacing: "0.02px", mt: '18px' }}>
                  Family Details
                </SubHeading>
              </Grid>
              <Grid item xs={12}>
                {families.map((familyMember, index) => (
                  <Box
                    key={index}
                    sx={(theme: Theme) => ({
                      p: '25px',
                      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                      border: `1px solid ${theme.palette.grey[100]}`,
                      display: 'flex', flexWrap: 'wrap',
                      borderRadius: '10px',
                      mt: '18px'
                    })}
                  >
                    <KeyValue title="Name" description={familyMember.name} />
                    <KeyValue title="Date of Birth" description={formatShortDate(familyMember.dob)} />
                    <KeyValue title="Relationship" description={familyMember.relationship} />
                    <KeyValue title="Tax ID" description={familyMember.taxId} />
                    <KeyValue title="Guradian Tax ID" description={familyMember.guardianTaxId} />
                    <KeyValue title="Mobile" description={familyMember.mobile ? (familyMember.countryCode
                      ? familyMember.countryCode + '-' + familyMember.mobile
                      : familyMember.mobile) : '-'} />
                    <KeyValue title="Gender" description={familyMember.gender} />
                  </Box>
                ))}
              </Grid>
            </Grid>} */}
          </Grid>
        </Box>
      </Box >
    </>
  );
}
